export const LsAnswerLabels = {
    itemsToRemove: 'What do you need removed?',
    locations: 'Where on the property are the items to remove?',
};

export const LsItemsToRemoveKey = 'itemsToRemove';

// Free-text answer for the "Other" checkbox, so it joins that list instead of taking a row.
export const LsOtherItemsKey = 'otherItems';

// The checkbox the free text above details; matched case-insensitively.
export const LsOtherItemValue = 'other';

// Matches a wire slug ('full_yard'). Anything carrying a space or a capital is the customer's
// own sentence and must not be re-cased.
export const LsSlugAnswerValue = /^[a-z0-9]+(?:[_-][a-z0-9]+)*$/;

// `uploadedImages` holds the hash ids of the photos the image row already renders.
export const LsSkippedAnswerKeys = ['uploadedImages'];
